import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareRedirectRoute: InvariantJiraRoute = {
	// the following route should be non-exact, it will handle "index" and "404" cases
	name: 'project-settings-software-redirect',
	path: '/jira/software/projects/:projectKey/settings',
};
